"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    }
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
require("./opensource.scss");
var Card_1 = require("./components/Card/Card");
var kelal_web_jpg_1 = __importDefault(require("../../../Assets/websitesAndProjects/kelal_web.jpg"));
var sun_web_jpg_1 = __importDefault(require("../../../Assets/websitesAndProjects/sun_web.jpg"));
var gerami_logo_s_jpg_1 = __importDefault(require("../../../Assets/websitesAndProjects/gerami_logo_s.jpg"));
var Opensource = /** @class */ (function (_super) {
    __extends(Opensource, _super);
    function Opensource() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Opensource.prototype.render = function () {
        return (react_1.default.createElement("div", { className: 'openSource-container' },
            react_1.default.createElement("h1", { style: { textAlign: 'center' } }, "previous works."),
            react_1.default.createElement("div", { className: 'p-openSource-container' },
                react_1.default.createElement(Card_1.Card, { img: kelal_web_jpg_1.default, link: 'https://www.kelaltech.com/', description: "Build yourself with technology , it will make things easier. our mission: to build tech that allows smoother information flow.\n          our values: Effectiveness, Efficiency, Honesty, Loyalty, Integrity and more..\n          " }),
                react_1.default.createElement(Card_1.Card, { img: sun_web_jpg_1.default, link: 'https://sun-it-solutions.herokuapp.com', description: 'SUN IT Solutions is a newly established (under formation) company to participate in the Implementation, Support and Training of Information Technology systems that helps our clients to achieve their business strategies and objectives' }),
                react_1.default.createElement(Card_1.Card, { img: gerami_logo_s_jpg_1.default, link: 'https://gerami.herokuapp.com/', description: 'Gerami is a collection of rich UI components library for React. All widgets are open source and free to use . Gerami is developed by Kelaltech , a startup company. ' }))));
    };
    return Opensource;
}(react_1.Component));
exports.Opensource = Opensource;



//////////////////
// WEBPACK FOOTER
// ./src/App/components/Opensource/Opensource.tsx
// module id = 84
// module chunks = 0